import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'PaperworkType/Master/List', method: 'POST', body: filter, token: token })
}
